import { Button, CircularProgress } from "@material-ui/core";
import { useCallback } from "react";
import { useServiceReservations } from "../../../graphql/hooks";

export type GenerateServicesReservationsReportProps = {
  serviceId?: string;
};
export function GenerateServicesReservationsReport(
  props: GenerateServicesReservationsReportProps
) {
  const { serviceId } = props;

  const {
    createServiceReservationReport,
    createServiceReservationReportLoading,
  } = useServiceReservations({
    onServiceReservationReportCreated(attachment) {
      window.open(attachment.url);
    },
  });

  const triggerCreateServicesReservationsReport = useCallback(() => {
    createServiceReservationReport({
      serviceId,
    });
  }, [createServiceReservationReport, serviceId]);

  return (
    <Button
      disabled={createServiceReservationReportLoading}
      onClick={triggerCreateServicesReservationsReport}
    >
      {!createServiceReservationReportLoading && "Scarica Report Prenotazioni"}
      {createServiceReservationReportLoading && <CircularProgress />}
    </Button>
  );
}
